import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { Link } from "react-router-dom";
import "./Helpchat.css";
import Contact from "./Contact";

const ChefPartySupport = () => {
  const [expandBoost, setExpandBoost] = useState(false);
  const expandBoostfunc = () => {
    setExpandBoost(!expandBoost);
  };

  const [openCollapse, setOpenCollapse] = useState({
    open1: false,
    open2: false,
    open3: false,
    open4: false,
    open5: false,
  });

  const handleCollapseToggle = (collapseKey) => {
    setOpenCollapse((prevState) => ({
      ...Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === collapseKey ? !prevState[key] : false;
        return acc;
      }, {}),
    }));
  };

  const handleClick = (event) => {
    // Prevent the collapse from closing when clicking on the link
    event.stopPropagation();
    // Your other click handler logic
  };

  return (
    <div className="ps-2">
      <div>
        <p style={{ color: "blue", fontWeight: "500" }}>
          Hi, we are here to help you
        </p>
        <p style={{ color: "#ff5c09" }}>Tips :</p>
        <ul style={{ fontSize: "12px" }}>
          <li>
            Update your profile, make it 100% complete to get listed in the
            search and contacted by Employers.
          </li>
          <li>
            Try to use application regularly, this will reflect on your profile
            and your profile will rank higher.
          </li>
          <li>Apply and connect with relevant jobs or events only.</li>
        </ul>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open1")}
          aria-controls="example-fade-text"
          aria-expanded={openCollapse.open1}
          className="help"
        >
          Profile
        </p>
        <Collapse in={openCollapse.open1}>
          <div id="example-fade-text1">
            <p style={{ fontSize: "12px" }}>
              Update your profile to get listed in the search and contacted by
              Employers.
            </p>
            <div>
              <Link
                onClick={handleClick}
                to="/cook/edit-cook-profile"
                style={{
                  display: "block",

                  fontSize: "14px",
                }}
              >
                Update Basic Profile
              </Link>
            </div>
            <div>
              <Link
                onClick={handleClick}
                to="/cook/edit-chef-profile"
                style={{
                  display: "block",

                  fontSize: "14px",
                }}
              >
                Update Chef Profile
              </Link>
            </div>
            <div>
              <Link
                onClick={handleClick}
                to="/cook/edit-party-profile"
                style={{
                  display: "block",

                  fontSize: "14px",
                }}
              >
                Update Party Profile
              </Link>
            </div>
            <div>
              <Link
                onClick={handleClick}
                to="/cook/edit-cook-profile"
                style={{
                  display: "block",

                  fontSize: "14px",
                }}
              >
                Update DP
              </Link>
            </div>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open2")}
          aria-controls="example-fade-text1"
          aria-expanded={openCollapse.open2}
          className="mt-3 help"
        >
          Jobs
        </p>
        <Collapse in={openCollapse.open2}>
          <div id="example-fade-text1">
            <Link
              onClick={handleClick}
              to="/cook/jobs"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              Find Jobs
            </Link>
            <Link
              onClick={expandBoostfunc}
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              Boost Profile
            </Link>
            {expandBoost && (
              <p style={{ fontSize: "12px" }}>
                You can boost your profile for certain days to get maximum
                number of responses by paying a small amount.
                <Link to="/cook/plans"> Continue (Plans)</Link>
              </p>
            )}
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open3")}
          aria-controls="example-fade-text2"
          aria-expanded={openCollapse.open3}
          className="mt-3 help"
        >
          Events
        </p>
        <Collapse in={openCollapse.open3}>
          <div id="example-fade-text2">
            <p style={{ fontSize: "12px" }}>
              Send interests to Clients and contact them to get quicker response
              which match to your profile in your location.
            </p>
            <Link
              onClick={handleClick}
              to="/cook/find-events"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Find Events
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open4")}
          aria-controls="example-fade-text3"
          aria-expanded={openCollapse.open4}
          className="mt-3 help"
        >
          Contact Settings
        </p>
        <Collapse in={openCollapse.open4}>
          <div id="example-fade-text3">
            <Link
              onClick={handleClick}
              to="/cook/profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              Add WhatsApp
            </Link>
            <Link
              to="/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Change Mobile Number
            </Link>
            <Link
              onClick={handleClick}
              to="/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Change Email
            </Link>
            <Link
              onClick={handleClick}
              to="/cook/settings"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Contact Privacy
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open5")}
          aria-controls="example-fade-text4"
          aria-expanded={openCollapse.open5}
          className="mt-3 help"
        >
          Contact Us
        </p>
        <Collapse in={openCollapse.open5}>
          <div id="example-fade-text4">
            <Contact />
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default ChefPartySupport;
